import { IntegrationTypeFilter } from '@modules/integrationsV2/components/IntegrationTypeFilter';
import { IntegrationsActionType } from '@modules/integrationsV2/store/integrationsActionType';
import { useIntegrationsStore } from '@modules/integrationsV2/store/integrationsStore';
import { integrationTypeFilterInDrawerValue } from '@modules/integrationsV2/types';
import { trackIntegrationPageEvent } from '@modules/integrationsV2/utils';
import { Stack, Typography } from '@mui/material';
import { toTitleCase } from 'v2/utils/strings';

export const AddNewIntegrationDrawerHeader = () => {
  const integrationTypeFilterInDrawer = useIntegrationsStore(
    ({ view }) => view.integrationTypeFilterInDrawer,
  );
  const dispatch = useIntegrationsStore(({ dispatch }) => dispatch);

  const getHeaderTitle = () => {
    if (integrationTypeFilterInDrawer === 'all') {
      return 'Add New Integration';
    }
    return `Add New ${toTitleCase(integrationTypeFilterInDrawer)} Integration`;
  };

  const handleChannelTypeFilterChange = (
    value: integrationTypeFilterInDrawerValue,
  ) => {
    dispatch({
      type: IntegrationsActionType.SET_VIEW,
      payload: {
        integrationTypeFilterInDrawer: value,
      },
    });
    trackIntegrationPageEvent({
      eventName:
        'Integrations - Add Integration Drawer: Selected Integration Type Filter Option',
    });
  };

  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      sx={{
        borderBottom: '1px solid',
        borderColor: 'divider',
        px: 3,
        py: 2,
      }}
    >
      <Stack direction="row" columnGap={2} alignItems="center">
        <Typography variant="h6">{getHeaderTitle()}</Typography>
      </Stack>
      <IntegrationTypeFilter
        value={integrationTypeFilterInDrawer}
        onChange={handleChannelTypeFilterChange}
      />
    </Stack>
  );
};
